module.exports = __webpack_public_path__ + "static/media/316.9ef8dffc.png";